import { InstanceFeatures, useGetFeatureStatusQuery } from 'store/instance-feature/api';

export const useODSEnabled = () => {
  const { data } = useGetFeatureStatusQuery(InstanceFeatures.ODS);
  return data?.status === 'active';
};
